(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);
  
    customElements.define('product-meta-loading', class extends baseComponent.default {
      
        render() {
            this.listenTo('variantLoading', () => {
                this.setAttribute('active', '');
            });
            this.listenTo('variantLoaded', () => {
                this.removeAttribute('active');
            })
        }
    });
})();